import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=2d5b4376&"
import script from "./Tabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./Tabs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=2d5b4376&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports